const TERMS = [
  {
    title: "Regular-priced items",
    body: "Eligible for a refund within 14 days of purchase. Items must be unworn, unwashed and returned with their original tags.",
  },
  {
    title: "Clearance & sale items",
    body: "Final sale. No refunds or exchanges on any item bought on clearance or at a sale price.",
  },
  {
    title: "Coupon purchases",
    body: "Final sale. No refunds or exchanges on any item purchased with a coupon or promotional code applied.",
  },
];

export const RefundPolicy = ({ brand }) => (
  <section
    data-testid="refund-policy-section"
    className="mt-20 border-t border-ink/10 pt-14"
  >
    <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-mutedink mb-3">
      Refund Policy
    </p>
    <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-ink mb-8">
      Returns at {brand}.
    </h2>
    <dl className="grid sm:grid-cols-3 gap-6">
      {TERMS.map((t, i) => (
        <div
          key={t.title}
          data-testid={`refund-term-${i + 1}`}
          className="bg-white border border-ink/10 p-6"
        >
          <dt className="font-serif text-lg text-ink">{t.title}</dt>
          <dd className="mt-3 text-sm text-mutedink leading-relaxed">
            {t.body}
          </dd>
        </div>
      ))}
    </dl>
    <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.15em] text-mutedink">
      The 14-day window starts on the date of purchase. Refunds are issued to
      the original payment method.
    </p>
  </section>
);
